import React from 'react';
import PropTypes from 'prop-types';

import TimePicker from "../../../../gd-ui/time-picker/v1/time-picker";
import DatetimeUtils from "core/gd/utils/datetime-utils";

export default class TimeRange extends React.Component {

    static propTypes = {
        timeRangeValue: PropTypes.object,

        skin: PropTypes.oneOf(['horizontal', 'vertical']),

        fromLabel: PropTypes.string,
        toLabel: PropTypes.string,

        format: PropTypes.string,
        timeStep: PropTypes.number, // minutes

        deleteAllowed: PropTypes.bool,

        onChange: PropTypes.func
    };

    static defaultProps = {
        skin: 'horizontal',
        fromLabel: "From",
        toLabel: "To",
        timeStep: 15,
        deleteAllowed: true
    }

    constructor(props) {
        super(props);

        this.timeRangeValue = props.timeRangeValue ? props.timeRangeValue : null;
    }

    componentDidMount() {
        if (!this.props.deleteAllowed && !this.timeRangeValue) this.addTimeRange(false);
    }

    update = () => {
        this.forceUpdate(()=>{if(this.props.onChange) this.props.onChange(this.timeRangeValue)});
    }

    addTimeRange = (update = true) => {
        this.timeRangeValue = Moment.range(DatetimeUtils.stickToSteps(Moment(), this.props.timeStep), DatetimeUtils.stickToSteps(Moment().add(1,'hour'), this.props.timeStep));
        if (update) this.update();
        else this.forceUpdate();
    }

    onChangeStart = (value) => {
        const duration = this.timeRangeValue.end.diff(this.timeRangeValue.start,'minutes')

        const start = Moment(value);
        const end = Moment(value).add(duration,'minutes');
        this.timeRangeValue = Moment.range(start, end);
        this.update();
    }

    onChangeEnd = (value) => {
        const start = Moment(this.timeRangeValue.start);
        const end = Moment(value);
        this.timeRangeValue = Moment.range(start, end);
        this.update();
    }

    onClearValues = () => {
        this.timeRangeValue = null;
        this.update();
    }

    render() {
        if (!this.timeRangeValue) {
            return <div className="gd-time-range empty" onClick={this.addTimeRange}><div className="icon i5-my-time m-r-10"/>Add time</div>
        } else {
            return (
                <div className={Classes("gd-time-range", this.props.skin+"-skin", {'with-delete':this.props.deleteAllowed})}>
                    <TimePicker className="time-selector"
                                value={this.timeRangeValue.start}
                                timeStep={this.props.timeStep}
                                popoverMinWidth={110}
                                onChange={this.onChangeStart}>
                        <div className="label ui5-txt-not-important-small">{this.props.fromLabel}</div>
                    </TimePicker>
                    <div className="time-selector-separator"/>
                    <TimePicker className="time-selector"
                                minValue={this.timeRangeValue.start}
                                value={this.timeRangeValue.end}
                                timeStep={this.props.timeStep}
                                popoverMinWidth={170}
                                onChange={this.onChangeEnd}>
                        <div className="label ui5-txt-not-important-small">{this.props.toLabel}</div>
                    </TimePicker>
                    {this.props.deleteAllowed && <div className="delete-button ui5-ico-delete s14 gray m-l-10" onClick={this.onClearValues}/>}
                </div>
            );
        }

    }
}